import React from 'react'
import { Field, FormSection, formValueSelector } from 'redux-form'
import { connect, useDispatch } from 'react-redux'
import { Select } from '../../../../../../../../../../itrust_common/components/form'
import {
  EYE_CONFIG,
  PRESCRIPTION_LENS_TYPES,
  SPECTERA_CLAIM_FORM,
  isSingleVisionPrescription,
} from './constants'
import {
  clearPrescriptionSection,
  copyAllPrescriptionOuFields,
  handlePrescriptionLensTypeChange,
} from './helpers'
import SpecteraPrescriptionEyeRow from './SpecteraPrescriptionEyeRow'

function SpecteraLabPrescriptionSection({
  prescriptionLensType,
  formValues,
  rightBal,
  leftBal,
  onLensTypeChange,
}) {
  const dispatch = useDispatch()
  const isSingleVision = isSingleVisionPrescription(prescriptionLensType)

  const handleLensTypeChange = (event, value) => {
    const selectedValue =
      value ?? event?.target?.value ?? event

    handlePrescriptionLensTypeChange(
      dispatch,
      prescriptionLensType,
      selectedValue
    )

    onLensTypeChange?.(selectedValue)
  }

  // Keep the rest of your existing JSX unchanged.

  return (
    <FormSection name="lab_prescription">
      <div className="d-flex justify-content-between align-items-center mb-4 mt-6">
        <h5 className="mb-0">Prescription</h5>
        <button
          type="button"
          className="btn btn-link btn-sm p-0"
          onClick={() => clearPrescriptionSection(dispatch)}
        >
          Clear
        </button>
      </div>

      <div className="row">
        <Field
          name="prescription_lens_type"
          label="Lens/Prescription Type"
          component={Select}
          data={PRESCRIPTION_LENS_TYPES}
          textField="label"
          valueField="value"
          placeholder="-- Select --"
          className="custom-select"
          wrapperClasses="form-group col-6"
          onChange={handleLensTypeChange}
        />
      </div>

      <FormSection name={EYE_CONFIG.left.section}>
        <SpecteraPrescriptionEyeRow
          eyePrefix={EYE_CONFIG.left.prefix}
          eyeShortLabel="OS"
          isSingleVision={isSingleVision}
          rowDisabled={rightBal}
        />
      </FormSection>

      <hr />

      <FormSection name={EYE_CONFIG.right.section}>
        <SpecteraPrescriptionEyeRow
          eyePrefix={EYE_CONFIG.right.prefix}
          eyeShortLabel="OD"
          isSingleVision={isSingleVision}
          rowDisabled={leftBal}
        />
      </FormSection>
    </FormSection>
  )
}

const selector = formValueSelector(SPECTERA_CLAIM_FORM)

const mapStateToProps = (state) => ({
  prescriptionLensType: selector(state, 'lab_prescription.prescription_lens_type'),
  formValues: state.form?.[SPECTERA_CLAIM_FORM]?.values || {},
  rightBal: Boolean(selector(state, 'lab_prescription.right_prescription.right_prescription_balance')),
  leftBal: Boolean(selector(state, 'lab_prescription.left_prescription.left_prescription_balance')),
})

export default connect(mapStateToProps)(SpecteraLabPrescriptionSection)
